import React from "react";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";

const GroupedFeaturesListings = ({ rowData }) => {
  const tbColumns = [
    {
      dataField: "feature_id",
      text: "feature name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.feature_name || "NA"}</span>;
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
      <PaymentLinkTable
        tableData={rowData?.feature_ids || []}
        tableColumns={tbColumns}
      />
    </div>
  );
};

export default GroupedFeaturesListings;
